import Container from "@/Components/User/Common/Container";
import BuyTicketModal from "@/Components/User/Modal/BuyTicketModal";
import { useBuy } from "@/context/buy";
import User from "@/Layouts/User";
import { AnimatePresence } from "framer-motion";
import { useRouter } from "next/router";
import { useCallback, useEffect, useRef, useState } from "react";
import { formatShortDateTime } from "@/Utils/dateFormat";
import Link from "next/link";
import MetaTags from "@/Components/SEO/MetaTags";

export default function index({ values, error }) {
  const router = useRouter();
  const {
    openSingleModal,
    openModal,
    selectedData,
    setSelectedData,
    setCustomModalData,
  } = useBuy();
  const [currentPage, setCurrentPage] = useState(0);
  const scrollRef = useRef();
  const [shows, setShows] = useState(values?.data || []);
  const [loading, setLoading] = useState(false);
  const [singleShowData, setSingleShowData] = useState();

  const handleScroll = useCallback(() => {
    if (!scrollRef.current) return;
    const div = scrollRef.current;
    const scrollTop = div.scrollTop;
    const scrollHeight = div.scrollHeight - div.clientHeight;
    const scrollPercent = (scrollTop / scrollHeight) * 100;
    if (shows?.length >= (currentPage + 1) * 10 && scrollPercent >= 95) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  }, [currentPage, shows?.length]);

  useEffect(() => {
    const div = scrollRef.current;
    if (div) {
      div.addEventListener("scroll", handleScroll);
      return () => {
        div.removeEventListener("scroll", handleScroll);
      };
    }
  }, [handleScroll]);

  const getButtonText = (show_date, show_time, status) => {
    if (
      !show_date ||
      !show_time ||
      typeof show_date !== "string" ||
      typeof show_time !== "string"
    ) {
      return "Invalid date provided.";
    }

    const showAt = new Date(`${show_date}T${show_time}Z`);

    if (isNaN(showAt.getTime())) return "Invalid date provided.";

    const nowUTC = new Date();
    const diffMs = showAt - nowUTC;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

    switch (status) {
      case 5:
        return "Ticket Expired";
      case 4:
        return "Ticket Used";
      case 1:
        return "Use Ticket";
      case 3:
        return "Ticket Transferred";
      case 2:
        return "Ticket Refunded";
      default:
        return "Unknown ticket status.";
    }
  };

  useEffect(() => {
    const fetchMoreShows = async () => {
      const formData = new FormData();
      formData.append("username", values?.username);
      formData.append("page_index", currentPage);
      formData.append("action", "getShowListByArtistUserName");
      try {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_BACKEND_URL}/webapi/manageShow`,
          {
            method: "POST",
            body: formData,
            headers: {
              ...(values?.authToken
                ? { Authorization: `Bearer ${values.authToken}` }
                : {}),
            },
          }
        );
        const newData = await res.json();
        if (newData?.data?.length) {
          if (currentPage == 0) {
            setShows(newData.data);
            if (newData.data.length == 1) {
              getSingleShowDetail(newData.data[0]?.id);
            }
          } else {
            setShows((prev) => [...prev, ...newData.data]);
          }
        }
      } catch (error) {
        console.error("Error loading more shows:", error);
      }
    };

    const getSingleShowDetail = async (id) => {
      const formData = new FormData();
      formData.append("action", "getShowDetail");
      formData.append("show_id", id);

      const res = await fetch(
        `${process.env.NEXT_PUBLIC_BACKEND_URL}/webapi/manageShow`,
        {
          method: "POST",
          body: formData,
        }
      );

      const newData = await res.json();

      if (res.ok) {
        setSingleShowData(newData.data);
      }
    };
    fetchMoreShows();
  }, [currentPage]);

  useEffect(() => {
    if (error) {
      sessionStorage.setItem("qoncer_error", error);
    }
  }, [error]);

  const slugify = (str) =>
    str
      ?.toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");
  return (
    <User ref={shows && shows.length > 1 ? scrollRef : null}>
      <MetaTags
        title={`${values?.artist_profile?.name || "Artist"} Tickets - Qoncert`}
        description={`Buy tickets for ${values?.artist_profile?.name}'s upcoming shows. Find concert dates, venues, and ticket prices.`}
        keywords={`${values?.artist_profile?.name} tickets, concert tickets, live music, ${values?.artist_profile?.name} tour, music events, qoncert tickets`}
        noindex={true}
      />
      {shows && shows.length > 0 ? (
        <div>
          <div className="relative">
            {openModal.buy && (
              <AnimatePresence>
                <div className="absolute">
                  <BuyTicketModal
                    showData={selectedData}
                    currentArtist={values?.artist_profile?.id}
                  />
                </div>
              </AnimatePresence>
            )}
          </div>
          <div>
            <Container className={`${shows.length == 1 ? "hidden" : ""}`}>
              <div className="px-6 mb-6 lg:px-0 mt-[30px] lg:mt-[50px] flex justify-center flex-col items-center ">
                <p className="mb-0 text-[30px] lg:text-[60px] lg:leading-[54px] font-[700] text-center ">
                  Choose Your Ticket
                </p>
                <p className="mt-6 mb-0 text-[16px] text-center lg:text-[30px] lg:leading-[54px] ">
                  <span className="font-[700] ">
                    {values?.artist_profile?.name}
                  </span>{" "}
                  has multiple shows coming up, <br />
                  which show are you buying a ticket for?
                </p>
              </div>
            </Container>
            <div
              className={`${shows.length == 1
                ? ""
                : "relative pt-[50px] h-fit overflow-hidden pb-[30px] lg:pt-[76px] "
                } `}
            >
              <div
                style={{
                  backgroundImage: `url('${values?.artist_profile?.profile}')`,
                  backgroundRepeat: "no-repeat",
                  minHeight: "100%",
                  marginTop: "-100px",
                }}
                className="layout_bg_image  hidden lg:block"
              >
                <span className="testing_innder_shadow"></span>
              </div>
              <Container
                className={` ${shows.length == 1 ? "" : "lg:pl-[180px] lg:pr-[215px]"
                  } `}
              >
                <div className="grid grid-cols-1 px-6 gap-[60px] lg:gap-[100px] md:grid-cols-3 sm:grid-cols-2">
                  {shows && shows.length > 0 ? (
                    shows.length == 1 ? (
                      <div className=" col-span-3  ">
                        <div
                          style={{
                            backgroundImage: `url('${shows[0]?.flyer_image
                              ? shows[0]?.flyer_image
                              : shows[0]?.banner
                              }')`,
                            backgroundRepeat: "repeat",
                          }}
                          className="layout_bg_image  hidden lg:block"
                        >
                          <span className="testing_innder_shadow"></span>
                        </div>
                        <Container>
                          <div className=" lg:pt-14 lg:pl-[91px] lg:pr-[45px] lg:gap-[180px] flex flex-col lg:flex-row items-start ">
                            <div className="pt-12">
                              <img
                                src={`${shows[0]?.flyer_image
                                  ? shows[0]?.flyer_image
                                  : shows[0]?.banner
                                  }`}
                                className="aspect-[1/1] object-cover lg:min-h-[360px] lg:max-w-[480px] rounded-2xl "
                                alt=""
                              />
                            </div>
                            <div className="pt-10 w-full lg:order-3">
                              <div
                                onClick={() =>
                                  router.push(
                                    `/artist/${values?.artist_profile?.username}`
                                  )
                                }
                                className="flex cursor-pointer items-start gap-5 lg:gap-10"
                              >
                                <img
                                  src={values?.artist_profile?.profile}
                                  className=" w-[60px] lg:w-[90px] aspect-[1/1] rounded-full border border-white "
                                  alt=""
                                />
                                <p className=" text-[24px] lg:text-[60px] lg:leading-[54px] font-[900]  ">
                                  {values?.artist_profile?.name}
                                </p>
                              </div>
                              <div className="mt-[25px] lg:mt-[73px] ">
                                <div className="mt-[10px] lg:mt-[31px] flex items-center gap-5 ">
                                  <p>
                                    <svg
                                      width="35"
                                      height="36"
                                      viewBox="0 0 35 36"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M4.09375 19.0202C4.09375 8.66434 7.36916 5.21338 17.1926 5.21338C27.0174 5.21338 30.2928 8.66434 30.2928 19.0202C30.2928 29.3761 27.0174 32.8271 17.1926 32.8271C7.36916 32.8271 4.09375 29.3761 4.09375 19.0202Z"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M4.48291 13.8816H29.9178"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M23.4137 19.7429H23.4264"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M17.1999 19.7429H17.2126"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M10.9743 19.7429H10.987"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M23.4137 25.4773H23.4264"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M17.1999 25.4773H17.2126"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M10.9743 25.4773H10.987"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M22.8551 3.05225V7.90861"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M11.5441 3.05225V7.90861"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </p>
                                  <p className="font-[700] text-xl lg:text-[28px]">
                                    {formatShortDateTime(
                                      shows[0]?.show_date.split(" ")[0],
                                      shows[0]?.show_date.split(" ")[1]
                                    )}
                                  </p>
                                </div>
                                <div className=" mt-[10px] lg:mt-[31px] flex items-center gap-5 ">
                                  <p>
                                    <svg
                                      width="35"
                                      height="37"
                                      viewBox="0 0 35 37"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M19.0791 5.82031V9.77336"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M19.0791 26.5796V29.8849"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M19.0791 22.1133V14.2397"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M30.5772 21.3785C26.7768 21.3785 26.7768 15.272 30.5772 15.272C30.5772 8.19667 30.5772 5.67139 17.1592 5.67139C3.74121 5.67139 3.74121 8.19667 3.74121 15.272C7.54167 15.272 7.54167 21.3785 3.74121 21.3785C3.74121 28.4552 3.74121 30.9804 17.1592 30.9804C30.5772 30.9804 30.5772 28.4552 30.5772 21.3785Z"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </p>
                                  <p className=" font-[700] text-xl lg:text-[28px] ">{`PRE: $${shows[0]?.ticket_price} | DOS: $${shows[0]?.day_of_show_price}`}</p>
                                </div>
                                <div className=" mt-[10px] lg:mt-[31px] flex items-center gap-5 ">
                                  <p>
                                    <svg
                                      width="34"
                                      height="37"
                                      viewBox="0 0 34 37"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M23.1967 14.4713V11.275C23.1967 7.53369 20.3182 4.49958 16.7687 4.49958C13.2193 4.4832 10.3295 7.50242 10.314 11.2452V11.275V14.4713"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M22.1512 32.0414H11.3588C8.40122 32.0414 6.00293 29.5149 6.00293 26.396V20.0106C6.00293 16.8917 8.40122 14.3652 11.3588 14.3652H22.1512C25.1088 14.3652 27.5071 16.8917 27.5071 20.0106V26.396C27.5071 29.5149 25.1088 32.0414 22.1512 32.0414Z"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M16.755 21.5503V24.8568"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </p>
                                  <p className=" font-[700] text-xl lg:text-[28px] ">{`Restrictions: ${singleShowData?.restriction}`}</p>
                                </div>
                                <div className=" mt-[10px] lg:mt-[31px] flex items-center gap-5 ">
                                  <p>
                                    <svg
                                      width="29"
                                      height="29"
                                      viewBox="0 0 29 29"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M17.139 12.6458C17.139 11.0343 15.8332 9.72852 14.2217 9.72852C12.6114 9.72852 11.3057 11.0343 11.3057 12.6458C11.3057 14.2561 12.6114 15.5618 14.2217 15.5618C15.8332 15.5618 17.139 14.2561 17.139 12.6458Z"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M14.2099 24.6504C10.8288 24.6504 5.46045 18.7688 5.46045 12.5155C5.46045 7.61993 9.37707 3.65039 14.2099 3.65039C19.0427 3.65039 22.9604 7.61993 22.9604 12.5155C22.9604 18.7688 17.5921 24.6504 14.2099 24.6504Z"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </p>
                                  <p className=" font-[700] text-xl lg:text-[28px] ">
                                    <span className="text-[#FA2CB4]">
                                      {shows[0]?.venue?.name}
                                    </span>{" "}
                                    •{" "}
                                    <span>
                                      {shows[0]?.venue?.city},{" "}
                                      {shows[0]?.venue.state}
                                    </span>{" "}
                                  </p>
                                </div>
                              </div>
                              <div className="hidden lg:block ">
                                <div className="flex flex-col gap-3 w-full lg:w-[450px]">
                                  {shows[0]?.is_ticket_booked && (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        router.push(
                                          `/tickets/${shows[0]?.booking_id}`
                                        );
                                      }}
                                      className="main_btn_bg"
                                    >
                                      <p>View Tickets</p>
                                    </button>
                                  )}
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (shows[0].venue_ticket_web_link) {
                                        openSingleModal("custom");
                                        setCustomModalData({
                                          showId: shows[0].id,
                                          link: shows[0].venue_ticket_web_link,
                                        });
                                        return;
                                      }
                                      if (shows[0]?.venue?.can_buy_tickets) {
                                        setSelectedData(shows[0]);
                                        openSingleModal("buy");
                                      }
                                    }}
                                    className={` 
                                      ${!loading ? "main_btn_bg" : ""} 
                                      rounded-[16px] lg:mt-[40px] 
                                      ${shows[0]?.venue?.can_buy_tickets ? "" : "disableBuyTicket"} 
                                      lg:text-[40px] lg:font-[900] lg:leading-[63px] lg:min-h-[103px] 
                                      max-w-[523px] w-full
                                    `}
                                  >
                                    <p className=" lg:py-5 ">
                                      Get Tickets
                                    </p>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="lg:hidden my-4 mb-6 w-full order-5">
                              <div className="flex flex-col items-center gap-2">
                                {shows[0]?.is_ticket_booked && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      router.push(
                                        `/tickets/${shows[0]?.booking_id}`
                                      );
                                    }}
                                    className="view_ticket_btn w-full lg:w-2/4 rounded-[12px] font-bold"
                                  >
                                    <p className="py-3 text-lg font-extrabold leading-[22px]">View Ticket</p>
                                  </button>
                                )}
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (shows[0].venue_ticket_web_link) {
                                      openSingleModal("custom");
                                      setCustomModalData({
                                        showId: shows[0].id,
                                        link: shows[0].venue_ticket_web_link,
                                      });
                                      return;
                                    }
                                    if (shows[0]?.venue?.can_buy_tickets) {
                                      if (shows[0]?.is_ticket_booked) {
                                        router.push(
                                          `/tickets/${shows[0]?.booking_id}`
                                        );
                                      } else {
                                        setSelectedData(shows[0]);
                                        openSingleModal("buy");
                                      }
                                    }
                                  }}
                                  className={` py-4  rounded-[16px] lg:mt-[40px] ${shows[0]?.venue?.can_buy_tickets
                                    ? ""
                                    : "disableBuyTicket"
                                    } lg:text-[40px] main_btn_bg lg:font-[900] lg:leading-[63px] lg:min-h-[103px]  max-w-[523px] w-full   `}
                                >
                                  <p className=" lg:py-5 ">
                                    Get Tickets
                                  </p>
                                </button>
                              </div>
                            </div>
                          </div>
                        </Container>
                      </div>
                    ) : (
                      shows.map((show, index) => {
                        let currentDate = new Date();
                        let show_at_time = new Date(show?.show_at);
                        let showName = false;
                        if (currentDate > show_at_time) {
                          showName = true;
                        }

                        const show_at = show?.show_date;
                        const finalDate = formatShortDateTime(
                          show_at.split(" ")[0],
                          show_at.split(" ")[1]
                        );
                        const city = slugify(show?.venue?.city);
                        const state = slugify(show?.venue?.state);
                        const showNames = slugify(show?.name);
                        const venueName = slugify(show?.venue?.name);
                        const showDate = show?.show_date.split(" ")[0];

                        const fullPath = `/shows/${city}-${state}/${show.id}-for-${showNames}-at-${venueName}-on-${showDate}`;
                        return (
                          <div
                            onClick={() => {
                              router.push(fullPath);
                            }}
                            className="cursor-pointer pb-1 "
                            key={index}
                          >
                            <img
                              src={
                                show?.flyer_image
                                  ? show?.flyer_image
                                  : show?.banner
                              }
                              className="w-full lg:aspect-[1/1] lg:w-[360px] object-cover rounded-[8px] "
                              alt=""
                            />
                            <div className="mt-6 text-center">
                              <p className="font-[700] text-xl leading-[20px] ">
                                {finalDate}
                              </p>
                              <p className="mt-4 text-lg font-[600] min-w-max ">
                                {show?.venue.name} in {show?.venue?.city},{" "}
                                {show?.venue?.state}{" "}
                              </p>
                              <div className="flex mt-4 justify-center w-full gap-2 flex-col">
                                {show?.is_ticket_booked && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      router.push(
                                        `/tickets/${show?.booking_id}`
                                      );
                                    }}
                                    className="view_ticket_btn py-3 rounded-xl"
                                  >
                                    <p className="py-[17px] text-lg dont-extrabold leading-[22px] ">View Tickets</p>
                                  </button>
                                )}
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (show.venue_ticket_web_link) {
                                      openSingleModal("custom");
                                      setCustomModalData({
                                        showId: show.id,
                                        link: show.venue_ticket_web_link,
                                      });
                                      return;
                                    }
                                    if (show?.venue?.can_buy_tickets) {
                                      setSelectedData(show);
                                      openSingleModal("buy");
                                    }
                                  }}
                                  className={` ${showName ? "hidden" : ""}   ${show?.venue?.can_buy_tickets
                                    ? ""
                                    : "disableBuyTicket"
                                    } w-full main_btn_bg rounded-2xl`}
                                >
                                  <p className="py-[18px] text-lg font-extrabold leading-[22px]">
                                    Get Tickets
                                  </p>
                                </button>
                              </div>
                              <button
                                className={` ${showName ? "" : "hidden"
                                  } bg-[#08080A] mt-4 w-full rounded-2xl`}
                              >
                                <p className="py-[18px] text-lg font-extrabold leading-[22px]">
                                  {show?.title}
                                </p>
                              </button>
                            </div>
                          </div>
                        );
                      })
                    )
                  ) : (
                    <div></div>
                  )}
                </div>
              </Container>
            </div>
          </div>
        </div>
      ) : (
        <div className="">
          <div
            style={{
              backgroundImage: `url('${values?.artist_profile?.profile}')`,
              backgroundRepeat: "repeat",
            }}
            className="layout_bg_image  hidden lg:block"
          >
            <span className="testing_innder_shadow"></span>
          </div>
          <Container>
            <div className="pl-6 pr-6 lg:pt-14 lg:pl-[91px] lg:pr-[175px] lg:gap-[180px] flex flex-col lg:flex-row items-start ">
              <img
                src="/assets/mobile5.png"
                className=" lg:aspect-[0.6/1] order-2 mt-10 lg:mt-0 lg:max-w-[400px] "
                alt=""
              />
              <div className="pt-10 lg:order-3">
                <div className="flex items-start gap-5 lg:gap-10">
                  <img
                    src={values?.artist_profile?.profile}
                    onClick={() => {
                      router.push(
                        `/artist/${values?.artist_profile?.username}`
                      );
                    }}
                    className="cursor-pointer w-[60px] lg:w-[90px] aspect-[1/1] rounded-full border border-white "
                    alt=""
                  />
                  <p className=" text-[24px] lg:text-[60px] lg:leading-[54px] font-[900]  ">
                    {values?.artist_profile?.name}
                  </p>
                </div>
                <div className="mt-[25px] lg:mt-[73px] ">
                  <div className="mt-[10px] lg:mt-[31px] flex items-center gap-5 ">
                    <p>
                      <svg
                        className=" w-[24px] h-[22px] lg:w-[38px] lg:h-[36px] "
                        viewBox="0 0 38 36"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.29663 19.0202C4.29663 8.66434 7.92014 5.21338 18.7875 5.21338C29.6565 5.21338 33.28 8.66434 33.28 19.0202C33.28 29.3761 29.6565 32.8271 18.7875 32.8271C7.92014 32.8271 4.29663 29.3761 4.29663 19.0202Z"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M4.72705 13.8816H32.8651"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M25.67 19.7429H25.684"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M18.7957 19.7429H18.8098"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M11.9088 19.7429H11.9228"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M25.67 25.4773H25.684"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M18.7957 25.4773H18.8098"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M11.9088 25.4773H11.9228"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M25.052 3.05225V7.90861"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12.5388 3.05225V7.90861"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </p>
                    <p className=" font-[700] text-xl lg:text-[28px] ">
                      Artists get booked for shows
                    </p>
                  </div>
                  <div className=" mt-[10px] lg:mt-[31px] flex items-center gap-5 ">
                    <p>
                      <svg
                        className=" w-[24px] h-[23px] lg:w-[38px] lg:h-[37px] "
                        viewBox="0 0 38 37"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20.8743 5.82031V9.77336"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M20.8743 26.5796V29.8849"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M20.8743 22.1133V14.2397"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M33.5943 21.3785C29.39 21.3785 29.39 15.272 33.5943 15.272C33.5943 8.19667 33.5943 5.67139 18.7503 5.67139C3.90625 5.67139 3.90625 8.19667 3.90625 15.272C8.11061 15.272 8.11061 21.3785 3.90625 21.3785C3.90625 28.4552 3.90625 30.9804 18.7503 30.9804C33.5943 30.9804 33.5943 28.4552 33.5943 21.3785Z"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </p>
                    <p className=" font-[700] text-xl lg:text-[28px] ">
                      Fans buy tickets for your fav artists
                    </p>
                  </div>
                </div>
                <div className="lg:mt-[200px] hidden lg:block ">
                  <button
                    onClick={() =>
                      window.open(
                        "https://play.qoncertapp.com/more-shows",
                        "_blank"
                      )
                    }
                    className=" lg:py-[18px] lg:w-[523px] lg:text-[40px] lg:font-[900]  bg-white text-black lg:rounded-2xl "
                  >
                    Book a Show
                  </button>
                </div>
              </div>
              <div className="lg:hidden w-full order-5">
                <div className=" mt-[50px] mb-[50px] lg:mt-[200px] lg:block ">
                  <button
                    onClick={() =>
                      window.open(
                        "https://play.qoncertapp.com/more-shows",
                        "_blank"
                      )
                    }
                    className="w-full py-[10px] rounded-[8px] font-[700] lg:py-[18px] lg:w-[523px] lg:text-[40px] lg:font-[900]  bg-white text-black lg:rounded-2xl "
                  >
                    Book a Show
                  </button>
                </div>
              </div>
            </div>
          </Container>
        </div>
      )}
    </User>
  );
}

export async function getServerSideProps(context) {
  try {
    const { slug } = context.params;
    const rawCookies = context.req.headers.cookie || "";
    let headers = {};
    const parsedCookies = Object.fromEntries(
      rawCookies.split("; ").map((cookie) => cookie.split("="))
    );

    let userData = {};
    if (parsedCookies.user_data) {
      try {
        userData = JSON.parse(decodeURIComponent(parsedCookies.user_data));
        headers = { Authorization: `Bearer ${userData?.web_token}` };
      } catch (error) {
        // Optional: handle cookie parse error
      }
    }

    if (!slug) return { notFound: true };

    const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL;
    const formData = new FormData();
    formData.append("username", slug);
    formData.append("page_index", 0);
    formData.append("action", "getShowListByArtistUserName");

    let data = null;

    try {
      const response = await fetch(`${BACKEND_URL}/webapi/manageShow`, {
        method: "POST",
        body: formData,
        headers,
      });

      data = await response.json();
    } catch (err) {
      // Instead of throwing, return error to page
      return {
        props: {
          values: null,
          error: `Failed to fetch show list data. ${err} `,
        },
      };
    }

    if (!data || !data.status) {
      return {
        props: {
          values: null,
          error: `Invalid response or no shows found. ${data}`,
        },
      };
    }

    return {
      props: {
        values: {
          ...data,
          username: slug,
          authToken: userData?.web_token || null,
        },
        error: null,
      },
    };
  } catch (error) {
    return {
      props: {
        values: null,
        error: `An unexpected error occurred. ${error}`,
      },
    };
  }
}
